import Lottie from 'react-lottie';
import { Flex, Text, Progress, Fade } from '@chakra-ui/react';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import animation from '../../lottie/loading_circle_dots_animation.json';
import Container from '../../common/container';
import PageHeader from '../../common/pageHeader';
import ContinueButton from '../../common/continueButton';
import {
  trackBuildingProfileContinueButtonTapped,
  trackBuildingProfilePageView,
} from '../../utils/analytics';
import ProgressBar from '../../common/progressBar';
import { useStores } from '../../store/rootStore';

const BuildingProfile = () => {
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animation,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice',
    },
  };

  const loadingLables = [
    { title: '', value: 0, delay: 0 },
    { title: 'loading<br>goals'.toUpperCase(), value: 10, delay: 1500 },
    { title: 'loading<br>motivations'.toUpperCase(), value: 20, delay: 2000 },
    { title: 'loading<br>fitness level'.toUpperCase(), value: 33, delay: 3000 },
    {
      title: 'building<br>music profile'.toUpperCase(),
      value: 50,
      delay: 4500,
    },
    { title: 'setting<br>personal best'.toUpperCase(), value: 80, delay: 6500 },
    { title: 'success'.toUpperCase(), value: 100, delay: 7300 },
  ];

  const [isFadedIn, setIsFadedIn] = useState(false);
  const [label, setLabel] = useState(loadingLables[0].title);
  const [value, setValue] = useState(loadingLables[0].value);

  const { getNextPagePath } = useStores();
  const navigate = useNavigate();

  const handleContinueButtonClick = () => {
    trackBuildingProfileContinueButtonTapped();
    navigate(getNextPagePath('BuildingProfile'));
  };

  useEffect(() => {
    trackBuildingProfilePageView();
    loadingLables.forEach((step) => {
      const intervalId = setInterval(() => {
        setLabel(step.title);
        setValue(step.value);
        clearInterval(intervalId);
      }, step.delay);
    });
    setIsFadedIn(true);
  }, []);

  return (
    <Container>
      <ProgressBar currentPage="BuildingProfile" />
      <PageHeader title="Building your personalized profile"></PageHeader>
      <Fade in={isFadedIn} transition={{ enter: { delay: 0.2, duration: 2 } }}>
        <Flex direction="column" align="center" justify="center" height="400px">
          <Lottie
            options={defaultOptions}
            height={400}
            width={400}
            speed={0.5}
          />
          <Text
            position={'absolute'}
            fontWeight="bold"
            fontStyle="italic"
            fontSize={'lg'}
            textAlign={'center'}
            dangerouslySetInnerHTML={{
              __html: label,
            }}
          ></Text>
        </Flex>
        <Progress
          value={value}
          backgroundColor={'#2D3748'}
          width={'58%'}
          size={'sm'}
          justifyContent={'center'}
          margin={'auto'}
          rounded={'4'}
          top={-8}
          sx={{
            '& > div:first-child': {
              transitionProperty: 'width',
            },
          }}
        />
      </Fade>
      <ContinueButton
        isDisabled={value < 100}
        onClick={handleContinueButtonClick}
      />
    </Container>
  );
};

export default BuildingProfile;
